import { ReactNode } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { DrawerDesktop } from "../navigation/DrawerDesktop";
import { DrawerMobile } from "../navigation/DrawerMobile";
import { useDrawer } from "../../utils/useDrawer";
import { Logo } from "../logo/Logo";

interface Props {
  children: ReactNode;
}

// Top-level chrome: left-hand drawer on desktop, hamburger app-bar +
// overlay drawer on mobile. The page content slots into the main area
// via children (props pattern; we don't use react-router <Outlet />
// since we wrap each authed route in <RequireAuth>+<AppLayout> in
// App.tsx).

export function AppLayout({ children }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { show } = useDrawer();

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      {isMobile && (
        <AppBar position="fixed" color="default" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={show}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Logo height={36} dark={theme.palette.mode === "dark"} />
            </Box>
            <Typography variant="subtitle2" sx={{ ml: 2, color: "text.secondary" }}>
              paim
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      {isMobile ? <DrawerMobile /> : <DrawerDesktop />}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: "100%",
          mt: isMobile ? "64px" : 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
